export const routeModuleLoaders = {
  dashboard: () => import('@/features/dashboard/DashboardPage'),
  invoices: () => import('@/features/invoices/InvoicesPage'),
  issueInvoice: () => import('@/features/invoices/IssueInvoicePage'),
  customers: () => import('@/features/customers/CustomersPage'),
  numbering: () => import('@/features/numbering/NumberingPage'),
  reports: () => import('@/features/reports/ReportsPage'),
  exports: () => import('@/features/exports/ExportsPage'),
  exceptions: () => import('@/features/exceptions/ExceptionsPage'),
  audit: () => import('@/features/audit/AuditPage'),
  iam: () => import('@/features/iam/IamPage'),
  settings: () => import('@/features/settings/SettingsPage'),
  enterprises: () => import('@/features/organization-management/EnterprisesPage'),
  brands: () => import('@/features/organization-management/BrandsPage'),
  stores: () => import('@/features/organization-management/StoresPage'),
  notFound: () => import('@/features/system/NotFoundPage'),
};

const routeLoaderByPath: Record<string, () => Promise<unknown>> = {
  '/dashboard': routeModuleLoaders.dashboard,
  '/invoices': routeModuleLoaders.invoices,
  '/invoices/issue': routeModuleLoaders.issueInvoice,
  '/customers': routeModuleLoaders.customers,
  '/numbering': routeModuleLoaders.numbering,
  '/reports': routeModuleLoaders.reports,
  '/exports': routeModuleLoaders.exports,
  '/exceptions': routeModuleLoaders.exceptions,
  '/audit': routeModuleLoaders.audit,
  '/iam': routeModuleLoaders.iam,
  '/settings': routeModuleLoaders.settings,
  '/enterprises': routeModuleLoaders.enterprises,
  '/brands': routeModuleLoaders.brands,
  '/stores': routeModuleLoaders.stores,
};

const modulePromises = new Map<string, Promise<unknown>>();

export function preloadRouteModule(path: string) {
  const loadModule = routeLoaderByPath[path];
  if (!loadModule) return Promise.resolve();
  const cached = modulePromises.get(path);
  if (cached) return cached;
  const promise = loadModule().catch(() => {
    modulePromises.delete(path);
    return undefined;
  });
  modulePromises.set(path, promise);
  return promise;
}
